import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { ROUTES } from "../../config/routes";

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate(ROUTES.HOMEPAGE);
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="flex align-items-center justify-content-center min-h-screen bg-gray-50">
      <Card className="w-30rem shadow-2">
        <div className="text-center">
          <div className="mb-4">
            <i className="pi pi-exclamation-triangle text-6xl text-orange-500 mb-3"></i>
            <h1 className="text-6xl font-bold text-gray-800 mb-2">404</h1>
            <h2 className="text-2xl font-semibold text-gray-700 mb-3">
              Page Not Found
            </h2>
            <p className="text-gray-600 mb-4">
              Sorry, the page you're looking for doesn't exist or has been
              moved.
            </p>
          </div>

          <div className="flex gap-3 justify-content-center">
            <Button
              label="Go Home"
              icon="pi pi-home"
              onClick={handleGoHome}
              className="p-button-primary"
            />
            <Button
              label="Go Back"
              icon="pi pi-arrow-left"
              onClick={handleGoBack}
              className="p-button-outlined p-button-secondary"
            />
          </div>
        </div>
      </Card>
    </div>
  );
};

export default NotFound;
